
let CardToCard=false;
let DebitCard=false;
let UserKyc=false;
let PhysicalCardCvv=false;
export const haspermissions={
    CardToCard,
    DebitCard,
    UserKyc,
    PhysicalCardCvv
}

